export default "__VITE_ASSET__BjtV86F2__"